<template>
  <div id="app" class="app">
    <router-view />
    <div id="errors" class="row">
      <div class="flex xs12" v-for="(error, index) in getErrors" :key="index">
        <ErrorMessage :errorMessage="error" :errorIndex="index" />
      </div>
    </div>
    <!--    <button v-if="audio.isLoad" type="button" class="btn no-radius btn-alarm" @click="closeAudioAlarm()"> {{audio.message ? audio.message : ''}}-->
    <!--      <va-icon :name='"fa fa-bell"'></va-icon> <span>Close</span>-->
    <!--    </button>-->
    <!--    <va-button style="position: relative; top: 55px; left: 555px;" icon="fa fa-bell" @click="playAlarmSound('Test')" />-->
  </div>
</template>

<script>
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import ErrorMessage from '@/components/errors/ErrorMessage.vue'
export default {
  name: 'app',
  data () {
    return {
      // Temporary config for 2.1.
      contextConfig: {
        gradient: true,
        shadow: 'lg', // 3 states: 'sm', 'lg', undefined (no shadow).
        invertedColor: false,
      },
    }
  },
  mixins: [errorHandlerMixin],
  components: {
    ErrorMessage,
  },
  methods: {
  },
  provide () {
    return {
      contextConfig: this.contextConfig,
    }
  },
  mounted () {
  },
  watch: {
    // Temporary colors fix for 2.1.
    'contextConfig.invertedColor' (val) {
      const invertedColorClass = 'va-inverted-color'
      if (val) {
        document.body.classList.add(invertedColorClass)
      } else {
        document.body.classList.remove(invertedColorClass)
      }
    },
  },
}
</script>

<style lang="scss">
@import '../sass/main.scss';

body {
  height: 100%;

  #app {
    height: 100%;
  }

  .va-input__container {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .va-select__dropdown {
    border-radius: 0;
  }
}
</style>
